import React, { ReactNode } from "react";
import { Button, DialogContentText } from "@mui/material";
import { BaseDialog } from "./BaseDialog";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmDisabled?: boolean;
  isProcessing?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  confirmDisabled = false,
  isProcessing = false,
  onConfirm,
  onCancel,
}) => {
  const actions = (
    <>
      <Button
        onClick={onCancel}
        color="primary"
        variant="outlined"
        disabled={isProcessing}
        style={{ textTransform: "none", border: "2px solid #005DAA" }}
      >
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        color="primary"
        variant="contained"
        disabled={confirmDisabled || isProcessing}
        style={{ textTransform: "none" }}
      >
        {confirmLabel}
      </Button>
    </>
  );

  return (
    <BaseDialog
      open={open}
      title={title}
      maxWidth="xs"
      fullWidth
      showDivider
      disabled={isProcessing}
      onClose={onCancel}
      actions={actions}
    >
      <DialogContentText>{message}</DialogContentText>
    </BaseDialog>
  );
};
